import isUndefined from "lodash.isundefined";
import isString from "lodash.isstring";
import isNull from "lodash.isnull";
import {
  DEFAULT_FOLDER_ID,
  virtualFolderIds,
  virtualFolderNames,
} from "../constants";

// Parses a variety of folderIds and always returns a string Id
const parseFolderId = (folderId?: string | null): string => {
  if (
    isUndefined(folderId) ||
    isNull(folderId) ||
    (isString(folderId) && folderId.length === 0) ||
    folderId === "NaN" ||
    folderId === "undefined"
  ) {
    return DEFAULT_FOLDER_ID;
  }

  if (virtualFolderIds.includes(folderId)) {
    return folderId;
  }

  if (!isUndefined(virtualFolderNames[folderId])) {
    return virtualFolderNames[folderId];
  }

  return folderId;
};

export default parseFolderId;
